
import { OrdersKeys } from '@/i18n/types/orders.types';

export const orders: Record<OrdersKeys, string> = {
  orders: 'Orders',
  myOrders: 'My Orders',
  orderNumber: 'Order #',
  orderDate: 'Order Date',
  orderStatus: 'Status',
  orderTotal: 'Total',
  products: 'Products',
  quantity: 'Quantity',
  price: 'Price',
  viewDetails: 'View Details',
  noOrders: 'No Orders Found',
  noOrdersMessage: 'You haven\'t placed any orders yet. Start shopping to see your orders here.',
  goShopping: 'Go Shopping',
  loadingOrders: 'Loading your orders...',
  paid: 'Paid',
  pending: 'Pending',
  failed: 'Failed',
  cancelled: 'Cancelled',
  processing: 'Processing',
  shipped: 'Shipped',
  delivered: 'Delivered',
  orderItems: 'Order Items',
  subtotal: 'Subtotal',
  total: 'Total',
  paymentMethod: 'Payment Method',
  shippingAddress: 'Shipping Address',
  billingAddress: 'Billing Address',
  orderSummary: 'Order Summary',
  backToOrders: 'Back to Orders',
  downloadInvoice: 'Download Invoice',
  trackOrder: 'Track Order',
  contactSupport: 'Contact Support',
  orderNotFound: 'Order not found',
  errorLoadingOrder: 'Error loading order details',
  refreshPage: 'Please refresh the page and try again',
};
